/**
 * This file implements function similar to lodash.keyBy
 * reason why we implement our own version is big size (20kB) of lodash version
 * witch contains a lot of features we don't need.
 */

/**
 * EXAMPLE
 * var array = [
 *  { 'dir': 'left', 'code': 97 },
 *  { 'dir': 'right', 'code': 100 }
 * ];
 * keyBy(array, 'dir');
 * => {
 *   'left': { 'dir': 'left', 'code': 97 },
 *   'right': { 'dir': 'right', 'code': 100 }
 * }
 */
export default (array, key) => {
  const result = {};

  const { length } = array;
  for (let i = 0; i < length; ++i) {
    const element = array[i];
    result[element[key]] = element;
  }

  return result;
};
